import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { SymptommsModel } from 'src/app/models/careteam/careteam';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CareTEamService } from 'src/app/services/care-team.service';
import { PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';

@Component({
  selector: 'app-covid-form',
  templateUrl: './covid-form.component.html',
  styleUrls: ['./covid-form.component.css']
})

export class CovidFormComponent implements OnInit {
  pageNum:any;
  totalPages:any;
  recentSymptomsError: boolean = false;
  visiReasonError: boolean = false;
  travelOutSideError: boolean = false;
  diagnosedOrSuspectedError: boolean = false;
  sympTomsModel!:  SymptommsModel;
  symptomNone!: boolean;
  patientPersonalInfo!: PatientPersonalInfo;
  checklist: any;
  settings:any;
  constructor(private _router: Router, private service: CareTEamService, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService) { 
    let info = localStorage.getItem('PersonalInfo');
    if(!info){
      this._router.navigateByUrl("/");
      return;
    }
    this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
    let havSetting = localStorage.getItem("financialCheck");
    if(havSetting){
      this.settings = JSON.parse(this.phrUtils.decrypt(havSetting));
      if(this.settings.data.enable_COVID19_Questionnaire.toLowerCase() !="true")
      {
        this._router.navigateByUrl("patient/thank-you");
      }
    }
    
    this.checklist = [
      { disabled: false, id: 1, label: 'Fever or Chills', isSelected: false },
      { disabled: false, id: 2, label: 'Cough', isSelected: false },
      { disabled: false, id: 3, label: 'Shortness of breath/ Difficulty in breathing', isSelected: false },
      { disabled: false, id: 4, label: 'Fatigue', isSelected: false },
      { disabled: false, id: 5, label: 'Muscle or body aches', isSelected: false },
      { disabled: false, id: 6, label: 'Headache', isSelected: false },
      { disabled: false, id: 7, label: 'New loss of taste and smell', isSelected: false },
      { disabled: false, id: 8, label: 'Sore throat', isSelected: false },
      { disabled: false, id: 9, label: 'Congestion or runny nose', isSelected: false },
      { disabled: false, id: 10, label: 'Nausea or vomiting', isSelected: false },
      { disabled: false, id: 11, label: 'Diarrhea', isSelected: false },
      { disabled: false, id: 12, label: 'None', isSelected: false },
    ];
    let pagesorder=localStorage.getItem('pagesorder');
    this.pageNum =JSON.parse(pagesorder?pagesorder:'').covid_form;
    this.totalPages=localStorage.getItem('totalPages');
  }
  
  ngOnInit(): void {
    this.sympTomsModel = new SymptommsModel();
    this.sympTomsModel.visitReason = this.patientPersonalInfo.REASON_NAME.toLowerCase();
  }
  
  disableOthers(e: any){
    this.symptomNone = false;
    let checked = e.target.checked;
    let id = e.target.id;
    if(checked && id == this.checklist[this.checklist.length-1].id){
      
      this.symptomNone = true;
      this.checklist.forEach((value: any, index: number) => {
        if(this.checklist[index].id != id){
          this.checklist[index].isSelected = false;
        }
      });
    }
    else{
      this.symptomNone = false;
      this.checklist[this.checklist.length-1].isSelected = false;
    }
  }
  
  radioBoxChange(e: any){
    let val = e.target.defaultValue;
    switch(val){
      case 'suspectedYes':{
        this.sympTomsModel.diagnosedOrSuspected = "true";
        this.diagnosedOrSuspectedError = false;
        break;
      }
      case 'suspectedNo':{
        this.sympTomsModel.diagnosedOrSuspected = "false";
        this.diagnosedOrSuspectedError = false;
        break;
      }
      case 'travelledYes':{
        this.sympTomsModel.travelOutSideNjLastTwoWeak = "true";
        this.travelOutSideError = false;
        break;
      }
      case 'travelledNo':{
        this.sympTomsModel.travelOutSideNjLastTwoWeak = "false";
        this.travelOutSideError = false;
        break;
      }
    }
  }
  
  backClick(){
    let goBackToConsent = localStorage.getItem("backToConsent");
    if(goBackToConsent && Number(goBackToConsent) === 1){
      localStorage.removeItem("backToConsent");
      this._router.navigateByUrl('patient/consent-form');
      return;
    }else
    {
      localStorage.setItem("backFromCovid","true");
      this._router.navigateByUrl('patient/intake');
    }
  }
  
  SaveCovidQuestionire(){
    if(this.validateRecentSymptoms()){
      this.SaveSymptoms();
    }
  }
  
  validateRecentSymptoms() : boolean {
    this.recentSymptomsError = true;
    this.checklist.forEach((value: any, index: number) => { 
      if (value.isSelected) {
        this.recentSymptomsError = false;
        switch(index){
          case 0:{
            this.sympTomsModel.feverOrChills = "true";
            break;
          }
          case 1:{
            this.sympTomsModel.cough = "true";
            break;
          }
          case 2:{
            this.sympTomsModel.shortnessOfBreathDifficultyBreathing = "true";
            break;
          }
          case 3:{
            this.sympTomsModel.fatigue = "true";
            break;
          }
          case 4:{
            this.sympTomsModel.muscleOrBodyAches = "true";
            break;
          }
          case 5:{
            this.sympTomsModel.headache = "true";
            break;
          }
          case 6:{
            this.sympTomsModel.newLossOfTasteOrSmell = "true";
            break;
          }
          case 7:{
            this.sympTomsModel.soreThroat = "true";
            break;
          }
          case 8:{
            this.sympTomsModel.congestionOrRunnyNose = "true";
            break;
          }
          case 9:{
            this.sympTomsModel.nauseaOrVomiting = "true";
            break;
          }
          case 10:{
            this.sympTomsModel.diarrhea = "true";
            break;
          }
          case 11 :{
            this.symptomNone = true;
            break;
          }
        }
      }
      else{
        switch(index){
          case 0:{
            this.sympTomsModel.feverOrChills = "false";
            break;
          }
          case 1:{
            this.sympTomsModel.cough = "false";
            break;
          }
          case 2:{
            this.sympTomsModel.shortnessOfBreathDifficultyBreathing = "false";
            break;
          }
          case 3:{
            this.sympTomsModel.fatigue = "false";
            break;
          }
          case 4:{
            this.sympTomsModel.muscleOrBodyAches = "false";
            break;
          }
          case 5:{
            this.sympTomsModel.headache = "false";
            break;
          }
          case 6:{
            this.sympTomsModel.newLossOfTasteOrSmell = "false";
            break;
          }
          case 7:{
            this.sympTomsModel.soreThroat = "false";
            break;
          }
          case 8:{
            this.sympTomsModel.congestionOrRunnyNose = "false";
            break;
          }
          case 9:{
            this.sympTomsModel.nauseaOrVomiting = "false";
            break;
          }
          case 10:{
            this.sympTomsModel.diarrhea = "false";
            break;
          }
          case 11 :{
            this.symptomNone = false;
            break;
          }
        }
      }
    });
    
    if(!this.sympTomsModel.diagnosedOrSuspected){
      this.diagnosedOrSuspectedError = true;
    }
    else{
      this.diagnosedOrSuspectedError = false;
    }
    if(!this.sympTomsModel.travelOutSideNjLastTwoWeak){
      this.travelOutSideError = true;
    }
    else{
      this.travelOutSideError = false;
    }
    if(this.sympTomsModel.visitReason.length < 1){
      this.visiReasonError = true;
    }
    else{
      this.visiReasonError = false;
    }
    if(this.recentSymptomsError || this.diagnosedOrSuspectedError || this.travelOutSideError || this.visiReasonError){
      return false;
    }
    return true;
  }
  
  SaveSymptoms(){
    this.spinner.show();
    this.sympTomsModel.first_name = this.patientPersonalInfo.FIRSTNAME;
    this.sympTomsModel.last_name = this.patientPersonalInfo.LASTNAME;
    this.sympTomsModel.patient_account = ""+this.patientPersonalInfo.PATIENT_ACCOUNT;
    this.sympTomsModel.practiceCode = this.patientPersonalInfo.PRACTICE_CODE;
    this.sympTomsModel.appointment_id = ""+this.patientPersonalInfo.APPOINTMENT_ID;
    this.service.covidQuestionnire(this.sympTomsModel).subscribe((res: any) => {
      this.spinner.hide();
      if(res && res.statusCode == 200 && res.message == "SUCCESS"){
        if(res.data.status == "link expired"){
          this.phrUtils.showError("Link expired.");
          this._router.navigateByUrl('/');
        }
        else if(res.data.status == "Success"){
          //this.phrUtils.showSuccess("Saved successfully");
          this._router.navigateByUrl('patient/thank-you');
        }
        else if(res.data.status == "Fail to insert symtoms"){
          this.phrUtils.showError("Failed to insert symtoms.");
        }
        else if(res.data.status == "Fail to update appointment"){
          this.phrUtils.showError("Failed to update appointment.");
        }
        else {
          this.phrUtils.showError("Service is not available, please try later.");
        }
      }
    }, (error: any) => {
      this.spinner.hide();
      this.phrUtils.showError("Service is not available, please try later.");
    });
  }
}